export enum AuthenticationType {
    GlobalLogin = "basic",
    GrundfosInternal = "grundfos"
}